var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-otp" },
    [
      _c("h3", { staticClass: "login-otp__title text-center mb-2" }, [
        _vm._v(" " + _vm._s(_vm.$t("login.otpVerification")) + " "),
      ]),
      _c("p", { staticClass: "login-otp__desc text-center mb-4" }, [
        _vm._v(" " + _vm._s(_vm.$t("login.otpDesc")) + " "),
      ]),
      !_vm.isSent
        ? _c("el-alert", {
            staticClass: "mb-4",
            attrs: {
              type: "warning",
              title: _vm.$t("login.otpSendFailed"),
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "login-otp__code mb-4" },
        _vm._l(_vm.digitIndexes, function (digitIndex) {
          return _c("input", {
            key: digitIndex,
            ref: "digit" + digitIndex,
            refInFor: true,
            staticClass: "login-otp__digit",
            class: {
              "login-otp__digit--active": _vm.isDigitActive(digitIndex),
            },
            attrs: {
              type: "text",
              inputmode: "text",
              autocomplete: "one-time-code",
              autocapitalize: "characters",
              autocorrect: "off",
              spellcheck: "false",
              maxlength: "1",
              "aria-label": _vm.$t("login.otpCode"),
              disabled: _vm.isLoading,
            },
            domProps: { value: _vm.otpDigits[digitIndex] },
            on: {
              input: function ($event) {
                return _vm.onDigitInput($event, digitIndex)
              },
              keydown: function ($event) {
                return _vm.onDigitKeyDown($event, digitIndex)
              },
              paste: function ($event) {
                return _vm.onDigitPaste($event, digitIndex)
              },
              focus: function ($event) {
                return _vm.onDigitFocus($event, digitIndex)
              },
              blur: _vm.onDigitBlur,
            },
          })
        }),
        0
      ),
      _c(
        "el-button",
        {
          staticClass: "w-100",
          attrs: {
            type: "primary",
            disabled: !_vm.isComplete,
            loading: _vm.isLoading,
          },
          nativeOn: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.$t("login.otpVerify")) + " ")]
      ),
      _c(
        "div",
        { staticClass: "login-otp__actions mt-3" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "text", disabled: _vm.isLoading },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.cancel.apply(null, arguments)
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("login.backToLogin")) + " ")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "text", disabled: _vm.isResendDisabled },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.resend.apply(null, arguments)
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.resendLabel) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }